import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const PianoPixelIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M46.4685 43.5044H40.5396V46.4692H46.4685V43.5044Z" fill={fillColor || 'black'} />
      <path d="M37.5754 43.5044H25.7168V46.4692H37.5754V43.5044Z" fill={fillColor || 'black'} />
      <path d="M22.7521 43.5044H10.8936V46.4692H22.7521V43.5044Z" fill={fillColor || 'black'} />
      <path d="M7.92893 43.5044H2V46.4692H7.92893V43.5044Z" fill={fillColor || 'black'} />
      <path
        d="M34.6098 7.9292H28.6809V22.7526H22.752V25.7167H28.6809V28.6815H25.7161V40.5401H37.5746V28.6815H34.6098V7.9292Z"
        fill={fillColor || 'black'}
      />
      <path
        d="M19.7878 7.9292H13.8588V22.7526H7.9292V25.7167H13.8588V28.6815H10.894V40.5401H22.7526V28.6815H19.7878V7.9292Z"
        fill={fillColor || 'black'}
      />
      <path d="M4.96482 7.9292H2V40.5401H7.92893V28.6815H4.96482V7.9292Z" fill={fillColor || 'black'} />
      <path
        d="M43.5041 22.7526H37.5752V25.7167H43.5041V28.6815H40.54V40.5401H46.4689V7.9292H43.5041V22.7526Z"
        fill={fillColor || 'black'}
      />
      <path d="M46.4687 2H2V4.96482H46.4687V2Z" fill={fillColor || 'black'} />
    </svg>
  );
};

export { PianoPixelIcon };
